/**
 * index.js
 * Entry point for the QuitPact React application.
 * Renders the root <App /> component into the DOM.
 *
 * Team: TA37 - The Coders' Assembly
 * Project: QuitPact - Smoking Cessation Relapse Risk Platform
 * Iteration: 1 | Epic: 1 - User Onboarding & Value Demonstration
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

/**
 * Wrap the entire application in <BrowserRouter> so React Router's
 * <Routes> / <Route> / <NavLink> / useNavigate() hooks are available
 * throughout the component tree.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
